import Hero from '../components/Hero'
import ServicePageLayout from '../components/ServicePageLayout'
import CallToActionLayout from '../components/CallToActionLayout'
import solarPanelImage from '../assets/images/solar_panelling_presentation.png'
import JourneySection from '../components/JourneySection'
import { journeySteps } from '../data/gaiaCustomerStory'

const SolarPanels = () => {
  const heroContent = {
    title: 'Solar Panel Installation',
    subtitle: 'Harness the Power of the Sun',
    description: 'Transform your home with premium solar panel systems. Reduce your energy bills, increase property value, and contribute to a greener future with expert installation.',
    ctaText: 'Get Free Solar Quote',
    ctaLink: '/quote/solar-panels',
    secondaryCtaText: 'Learn More',
    secondaryCtaLink: '#benefits',
    image: solarPanelImage,
    imageAlt: 'Solar panels installed on residential roof'
  }

  const serviceData = {
    title: "Solar Panel Installation",
    subtitle: "Harness the power of the sun for your home",
    description: "Transform your home with our premium solar panel systems. Reduce your energy bills, increase your property value, and contribute to a greener future with our expert installation services.",
    benefits: [
      "Significantly reduce electricity bills",
      "Generate clean, renewable energy",
      "Increase property value by up to 4%",
      "Government incentives available",
      "25-year manufacturer warranty",
      "Professional installation and maintenance"
    ],
    features: [
      {
        title: "Smart Export Guarantee",
        description: "Get paid for excess electricity exported back to the grid through your energy supplier."
      },
      {
        title: "Optimised System Design",
        description: "Designed using detailed energy modelling to maximise self-consumption and long-term performance."
      },
      {
        title: "Battery-Ready Installation",
        description: "Pre-configured for battery storage, allowing simple upgrades without rework."
      },
      {
        title: "Grid Connection Management",
        description: "DNO applications and grid notifications managed as part of your installation journey."
      },
      {
        title: "Solar and EV Integration",
        description: "Use solar generation to power your electric vehicle and reduce charging costs."
      },
      {
        title: "Precision Installation",
        description: "Installed by in-house teams with a focus on safety, accuracy, and long-term reliability."
      },
    ],
    videoEmbedId: "false" // Placeholder YouTube ID
  }

  return (
    <div>
      <Hero
        layout="split"
        content={heroContent}
      />
      <div id="benefits">
        <ServicePageLayout {...serviceData} />
      </div>
      {/* Journey Section */}
      <JourneySection
        title="Wash your clothes without worry"
        steps={journeySteps}
        backgroundColor="gray"
      />
      <CallToActionLayout
        cta_title="Join the solar revolution"
        description="Get a free, personalised quotation for your solar panel installation.
        Our experts will assess your roof and provide detailed cost projections and energy savings estimates."
        quote_link='/quote/solar'
      />
    </div>
  )
}

export default SolarPanels